<template>
  <a-select allowClear v-model="tmpValue" v-bind="$attrs" v-on="$listeners" placeholder="账单类型">
    <a-select-opt-group v-for="(item, index1) in groupOpts" :key="index1">
      <span slot="label"><a-icon type="caret-right"/> {{ item.label }}</span>
      <a-select-option v-for="(option, index2) in item.options" :key="index2" :value="option.value">
        {{ option.label }}
      </a-select-option>
    </a-select-opt-group>
  </a-select>
</template>

<script>
import enums from "@/utils/enums";

export default {
  name: "IncomeTypeSelect",
  data() {
    return {
      groupOpts: enums.Income.Type.options(),
    }
  },
  computed: {
    tmpValue: {
      get() {
        return this.$attrs.value ? this.$attrs.value : undefined;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
}
</script>

<style scoped>

</style>